// extracted by mini-css-extract-plugin
export default {"map":"Map_map__S25BK","map__iframe":"Map_map__iframe__sckl2"};